import { AuthGuard, NoAuthGuard } from './shared/guards';
import { NgModule, inject } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthorizedLayoutComponent } from './layout/authorized-layout/authorized-layout.component';
import { ROUTER_PATHS } from './shared/constants';
import { UnauthorizedLayoutComponent } from './layout/unauthorized-layout/unauthorized-layout.component';
import { CanDeactivateGuard } from './shared/guards/clear.guard';

const routes: Routes = [
  {
    path: ROUTER_PATHS.auth.root,
    component: UnauthorizedLayoutComponent,
    loadChildren: async () => (await import('./auth/auth.module')).AuthModule,
    canMatch: [() => inject(NoAuthGuard).canMatch()]
  },
  {
    path: '',
    component: AuthorizedLayoutComponent,
    canMatch: [() => inject(AuthGuard).canMatch()],
    children: [
      {
        path: ROUTER_PATHS.dashboard.root,
        loadChildren: async () => (await import('./pages/dashboard/dashboard.module')).DashboardModule
      },
      {
        path: ROUTER_PATHS.customers.root,
        loadChildren: async () => (await import('./pages/user-management/user-management.module')).UserManagementModule
      },
      {
        path: ROUTER_PATHS.projects.root,
        canDeactivate: [CanDeactivateGuard],
        loadChildren: async () =>
          (await import('./pages/project-management/project-management.module')).ProjectManagementModule
      },
      {
        path: ROUTER_PATHS.profile.root,
        loadChildren: async () => (await import('./pages/profile/profile.module')).ProfileModule
      },
      {
        path: `${ROUTER_PATHS.error.notFound}`,
        pathMatch: 'full',
        loadComponent: async () =>
          (await import('./pages/page-not-found/page-not-found.component')).PageNotFoundComponent
      },
      { path: '', redirectTo: ROUTER_PATHS.dashboard.root, pathMatch: 'full' },
      {
        path: `**`,
        redirectTo: `${ROUTER_PATHS.error.notFound}`
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
